import { ReactNode } from "react";
import { useParams } from "react-router-dom";

import {
  useMerchantApiQueryWithParams,
  useReactRouterLink,
} from "../../../hooks";
import {
  IModalFormProps,
  IViewBankTransferBeneficiary,
} from "../../../interfaces-and-types";

import { View } from "./View";
export interface IBeneficiaryDetailsModalViewProps extends IModalFormProps {
  modalData: IViewBankTransferBeneficiary | null;
  beneficiaryPaymentsSearchQuery?: string | null;
  enableSearchBeneficiaryPayments: boolean;
  invoiceData: ReactNode[];
  subscriptionData: ReactNode[];
}

export const BankBeneficiaryDetailsModal = () => {
  const { location, navigateToRoutePreserveParams } = useReactRouterLink();

  const closeModal = () => {
    navigateToRoutePreserveParams(
      location.pathname.replace(`/${id}/details`, "")
    );
  };

  const { id } = useParams();

  const {
    isLoading: isLoadingBeneficiary,
    isSuccess: isSuccessBeneficiary,
    isError: isErrorBeneficiary,
    data: beneficiary,
  } = useMerchantApiQueryWithParams<
    { id: string },
    IViewBankTransferBeneficiary
  >(
    [
      "getBankTransferBeneficiaryById",
      {
        id: id!, // NOTE: used to enforce react query cache with correct queryKey
      },
    ],
    {
      enabled: !!id,
    },
    (urlTemplate) => urlTemplate.replace("id", id!)
  );

  return (
    <View
      isLoadingModalData={isLoadingBeneficiary}
      isErrorModalData={isErrorBeneficiary}
      isModalOpen={!!id}
      closeModal={closeModal}
      modalData={beneficiary || null}
      beneficiaryPaymentsSearchQuery={beneficiary?.email}
      enableSearchBeneficiaryPayments={isSuccessBeneficiary}
      invoiceData={[]}
      subscriptionData={[]}
    />
  );
};
